module.exports = __webpack_public_path__ + "static/media/notification-icon.f773f6c0.svg";